const state = {
    me: null,
    navTitle: '',
};

const getters = {
    isLogined: state => !!state.me,
    isExternalDisplay: state => state.me.perms.includes('display'),
};

const mutations = {
    setMe(state, user) {
        state.me = user;
    },
    setNavTitle(state, title) {
        state.navTitle = title;
    }
};

const actions = {

};

export default {
    state,
    getters,
    actions,
    mutations,
    namespaced: true,
}

